import job from './job';

export default job;
